var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBnbLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "8rkr4wjmya",
    x: 7.831,
    y: 27.294,
    width: 41.401,
    height: 37.271,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bdbk8jr3ac",
    x: 58.835,
    y: 26.74,
    width: 41.52,
    height: 37.169,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "92iw9p9d9d",
    x: 10.402,
    y: 54.443,
    width: 41.272,
    height: 39.149,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "57qbnjkkoe",
    x: 44.868,
    y: 44.869,
    width: 18.263,
    height: 18.263,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cch4xxvwxf",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fwy9awd35g",
    x: 35.334,
    y: 59.017,
    width: 37.727,
    height: 39.623,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2twpsw7umh",
    x: 19.777,
    y: 7.876,
    width: 36.175,
    height: 42.036,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "61oz2itq4i",
    x: 56.687,
    y: 54.22,
    width: 41.322,
    height: 39.049,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "goyjp3nacj",
    x: 51.914,
    y: 7.844,
    width: 35.718,
    height: 42.049,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ydi2epoynb",
    x1: -0.489,
    y1: -0.117,
    x2: 1.967,
    y2: 2.058,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0d30b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fac313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b90b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b54e3"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3213"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3212"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3688"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3687"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#8rkr4wjmya)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3680"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m462.495 382.725 13.173-3 12.726-2.9a4.532 4.532 0 0 0 2.606-7.383 8.9 8.9 0 0 0-1.509-1.3q-5.45-4.111-10.915-8.2-4.819-3.619-9.636-7.242a4.96 4.96 0 0 0-2.915-1.094c-2.526-.066-3.988 1.8-4.936 4.148a58.058 58.058 0 0 0-3.273 10.126 64.1 64.1 0 0 0-1.126 12.513 4.6 4.6 0 0 0 3.744 4.387 4.452 4.452 0 0 0 2.061-.055z",
    transform: "translate(-445.859 -322.315)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#bdbk8jr3ac)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3681"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m844.982 378.744-13.233-2.717-12.785-2.627a4.532 4.532 0 0 1-2.768-7.331 8.9 8.9 0 0 1 1.481-1.332q5.361-4.226 10.738-8.431 4.741-3.721 9.479-7.446a4.961 4.961 0 0 1 2.891-1.155c2.525-.12 4.026 1.72 5.023 4.042A58.079 58.079 0 0 1 849.3 361.8a64.1 64.1 0 0 1 1.392 12.486 4.6 4.6 0 0 1-3.65 4.466 4.452 4.452 0 0 1-2.06-.008z",
    transform: "translate(-753.325 -318.96)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#92iw9p9d9d)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3682"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m497.6 572.859 6.053-12.078 5.847-11.668a4.532 4.532 0 0 0-4.047-6.71 8.892 8.892 0 0 0-1.963.339q-6.637 1.6-13.268 3.22-5.857 1.423-11.714 2.841a4.96 4.96 0 0 0-2.7 1.556c-1.656 1.909-1.14 4.227.068 6.447a58.075 58.075 0 0 0 5.741 8.96 64.136 64.136 0 0 0 8.948 8.818 4.6 4.6 0 0 0 5.767-.1 4.453 4.453 0 0 0 1.268-1.625z",
    transform: "translate(-461.358 -485.958)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#57qbnjkkoe)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 218",
    cx: 6.131,
    cy: 6.131,
    r: 6.131,
    transform: "translate(47.87 46.87)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#cch4xxvwxf)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 4116",
    d: "M452.681 160.923v3.65a46.143 46.143 0 0 1 .341 92.283h-.392a46.143 46.143 0 0 1 .048-92.285v-3.65m0-1.163a51 51 0 0 0-.048 102h.434a51 51 0 0 0-.385-102z",
    transform: "translate(-398.65 -157.76)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#fwy9awd35g)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3683"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m681.247 601.486-5.647-12.274-5.451-11.858a4.532 4.532 0 0 0-7.767-1.036 8.894 8.894 0 0 0-.962 1.744q-2.9 6.179-5.781 12.369-2.551 5.46-5.106 10.919a4.96 4.96 0 0 0-.471 3.077 4.576 4.576 0 0 0 5.325 3.678q.157-.029.312-.068c1.6-.412 3.215-.8 4.823-1.194 1.387-.341 2.776-.67 4.158-1.022a4.313 4.313 0 0 1 2.251-.072c1.6.43 3.214.8 4.82 1.206 1.321.33 2.641.659 3.959 1a4.972 4.972 0 0 0 2.485.1 4.6 4.6 0 0 0 3.524-4.566 4.454 4.454 0 0 0-.472-2.003zm-16.8 2.109c-1.623.373-3.233.8-4.85 1.2-1.552.386-3.1.812-4.659 1.143a2.414 2.414 0 0 1-2.838-2.738 10 10 0 0 1 .955-2.436q2.333-5.073 4.7-10.134 2.9-6.229 5.806-12.452a4.273 4.273 0 0 1 .463-.752 1.943 1.943 0 0 1 1.243-.75.5.5 0 0 1 .591.376c0 .016.006.033.008.049a1.576 1.576 0 0 1 .006.228v12.355h.01c0 4.042-.013 8.084.009 12.126a1.672 1.672 0 0 1-1.441 1.787z",
    transform: "translate(-611.656 -513.543)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#2twpsw7umh)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3684"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m570.089 219.771.375 13.5.362 13.046a4.532 4.532 0 0 1-6.505 4.368 8.911 8.911 0 0 1-1.635-1.138q-5.338-4.255-10.659-8.531-4.7-3.767-9.413-7.53a4.96 4.96 0 0 1-1.785-2.551c-.693-2.431.755-4.312 2.789-5.813a58.084 58.084 0 0 1 8.993-5.69 64.111 64.111 0 0 1 11.839-4.205 4.6 4.6 0 0 1 5.181 2.534 4.45 4.45 0 0 1 .458 2.01z",
    transform: "translate(-517.883 -205.243)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#61oz2itq4i)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3685"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m812.717 571.224-6.15-12.028-5.941-11.621a4.532 4.532 0 0 1 3.992-6.742 8.887 8.887 0 0 1 1.965.323q6.649 1.543 13.293 3.113 5.868 1.375 11.737 2.746a4.961 4.961 0 0 1 2.709 1.534c1.671 1.9 1.174 4.217-.016 6.447a58.089 58.089 0 0 1-5.668 9.004 64.125 64.125 0 0 1-8.877 8.891 4.6 4.6 0 0 1-5.767-.057 4.452 4.452 0 0 1-1.277-1.61z",
    transform: "translate(-740.393 -484.611)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#goyjp3nacj)"
    },
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 3686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614-2",
    d: "m766.531 219.678.018 13.51.017 13.051a4.532 4.532 0 0 0 6.63 4.177 8.894 8.894 0 0 0 1.6-1.185q5.212-4.408 10.407-8.837 4.593-3.9 9.19-7.8a4.961 4.961 0 0 0 1.71-2.6c.622-2.45-.88-4.288-2.956-5.729a58.064 58.064 0 0 0-9.154-5.427 64.114 64.114 0 0 0-11.956-3.859 4.6 4.6 0 0 0-5.106 2.683 4.453 4.453 0 0 0-.4 2.016z",
    transform: "translate(-711.606 -205.046)",
    style: {
      fill: "url(#ydi2epoynb)"
    }
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLime);
export default __webpack_public_path__ + "static/media/bnbLime.9d217e83abe6fa31bded2fda68276a80.svg";
export { ForwardRef as ReactComponent };